import React from 'react';
import { Box } from '@mui/material';
import { mvkgTokens } from '../../theme/mvkgTokens';
import { surfaceFor } from './statusMaps';

/** Compact label·value pill (e.g. "CD5 0.94", "Survival 82%"). */
export default function StatPill({ label, value, accent = 'gray', sx = {} }) {
  const surf = surfaceFor(accent);
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 0.6,
        px: 1,
        py: 0.4,
        borderRadius: 1.5,
        bgcolor: surf.bg,
        color: surf.fg,
        fontFamily: mvkgTokens.font.mono,
        fontSize: '0.7rem',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {label && (
        <Box component="span" sx={{ opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          {label}
        </Box>
      )}
      {value != null && <Box component="span">{value}</Box>}
    </Box>
  );
}
